<ng-select
	[clearable]="isClearable()"
	[disabled]="disabled"
	[(items)]="people"
	(change)="selectEmployee($event)"
	[(ngModel)]="selectedEmployee"
	[placeholder]="placeholder || 'FORM.PLACEHOLDERS.ALL_EMPLOYEES' | translate"
	[searchFn]="searchEmployee"
	bindName="firstName"
	appendTo="body"
>
	<ng-template ng-option-tmp let-item="item" let-index="index">
		<img
			*ngIf="item.imageUrl"
			[src]="item.imageUrl"
			width="40"
			height="40"
		/>
		{{ getFullName(item.firstName, item.lastName) }}
	</ng-template>
	<ng-template ng-label-tmp let-item="item">
		<div class="selector-template">
			<img
				*ngIf="item.imageUrl"
				height="25"
				width="25"
				[src]="item.imageUrl"
			/>
			<span>{{ getShortenedName(item.firstName, item.lastName) }}</span>
		</div>
	</ng-template>
</ng-select>
